import React, { useMemo } from "react";
import { Avatar, Box, Card, Stack } from '@mui/material';
import { Doughnut } from 'react-chartjs-2';
import { ChartColors } from "common/ChartColors";
import { Utils } from 'common/Utils';

export default function AximDoughnut ({ title, data, isCurrency, showStack=true, showTotal=true }) {
    const doughnutData = useMemo(() => {
        return {
            labels: data.map(d => d.label),
            datasets: [
                {
                    data: data.map(d => d.value),
                    backgroundColor: ChartColors.Colors,
                    borderColor: ChartColors.Colors,
                    borderWidth: 1,
                },
            ],
        }
    },[data]);

    const formatLabel = (label, value) => {
        if (label) {
            label += ': ';
        }
        if (value !== null) {
            label += isCurrency ? Utils.formatCurrency(value) : value;
        }
        return label;
    }

    const options = useMemo(() => {
        var o = {
            plugins: {
                tooltip: {
                    callbacks: {
                        label: function(context) {
                            return formatLabel(context.label || '', context.parsed);
                        }
                    }
                },
                legend: {
                    display: false,
                    position: "right",
                    labels: {
                        generateLabels: (chart) => {
                            const datasets = chart.data.datasets;
                            return datasets[0].data.map((data, i) => ({
                                text: formatLabel(chart.data.labels[i], data),
                                fillStyle: datasets[0].backgroundColor[i],
                            }))
                        }
                    }
                }
            }
        }

        if (title) {
            o.plugins.title = {
                display: true,
                text: title,
                font: {
                    size: 30,
                    weight: 'bold',
                }
            }
        }

        return o;
    },[title, data]);

    const plugins = useMemo(() => {
        if(showTotal){
        var sum = data.map(e => e.value).reduce((a, b) => a + b, 0);

        return [{
            id: 'text',
            beforeDraw: function(chart, a, b) {
                var width = chart.width,
                height = chart.height,
                ctx = chart.ctx;

                ctx.restore();
                var fontSize = (height / 220).toFixed(2);
                ctx.font = fontSize + "em sans-serif";
                ctx.textBaseline = "middle";

                var text =  isCurrency ? Utils.formatCurrency(sum) : sum,
                textX = Math.round((width - ctx.measureText(text).width) / 2),
                textY = (height + chart.titleBlock.height) / 2;

                // ctx.fillStyle = theme.palette.primary.main;
                ctx.fillText(text, textX, textY);
                ctx.save();
            }
        }]
    }
    else
    {
        return[{}]
    }
    },[data]);

    return (
        <Box maxWidth={400}>
            <Doughnut
                data={doughnutData}
                options={options}
                plugins={plugins}
            />
            <Stack spacing={1} hidden={!showStack} >
                {data.map((e,i) =>
                    <Card key={i} className="d-flex p-1" style={{ justifyContent: "space-between"}}>
                        <Stack direction="row" spacing={1}>
                            <Avatar sx={{ bgcolor: ChartColors.getColor(i), width: 24, height: 24}}> </Avatar>
                            <Box>{e.label}</Box>
                        </Stack>
                        <Box>{isCurrency ? Utils.formatCurrency(e.value) : e.value}</Box>
                    </Card>
                )}
            </Stack>
        </Box>
    )
}